import variants_avatar_default from "./variants_avatar.js";
import variants_badge_default from "./variants_badge.js";
import variants_banner_default from "./variants_banner.js";
import variants_button_default from "./variants_button.js";
import variants_button_group_default from "./variants_button_group.js";
import variants_box_default from "./variants_box.js";
import variants_breadcrumbs_default from "./variants_breadcrumbs.js";
import variants_card_default from "./variants_card.js";
import variants_checkbox_default from "./variants_checkbox.js";
import variants_checkbox_group_default from "./variants_checkbox_group.js";
import variants_chip_default from "./variants_chip.js";
import variants_collapsible_default from "./variants_collapsible.js";
import variants_combobox_default from "./variants_combobox.js";
import variants_combobox_with_popover_default from "./variants_combobox_with_popover.js";
import variants_datepicker_default from "./variants_datepicker.js";
import variants_description_list_default from "./variants_description_list.js";
import variants_dropdown_default from "./variants_dropdown.js";
import variants_emoji_default from "./variants_emoji.js";
import variants_emoji_picker_default from "./variants_emoji_picker.js";
import variants_emoji_text_wrapper_default from "./variants_emoji_text_wrapper.js";
import variants_empty_state_default from "./variants_empty_state.js";
import variants_filter_pill_default from "./variants_filter_pill.js";
import variants_hovercard_default from "./variants_hovercard.js";
import variants_icon_default from "./variants_icon.js";
import variants_illustration_default from "./variants_illustration.js";
import variants_image_viewer_default from "./variants_image_viewer.js";
import variants_input_default from "./variants_input.js";
import variants_input_group_default from "./variants_input_group.js";
import variants_item_layout_default from "./variants_item_layout.js";
import variants_keyboard_shortcut_default from "./variants_keyboard_shortcut.js";
import variants_lazy_show_default from "./variants_lazy_show.js";
import variants_link_default from "./variants_link.js";
import variants_list_item_default from "./variants_list_item.js";
import variants_list_item_group_default from "./variants_list_item_group.js";
import variants_loader_default from "./variants_loader.js";
import variants_modal_default from "./variants_modal.js";
import variants_mode_island_default from "./variants_mode_island.js";
import variants_notice_default from "./variants_notice.js";
import variants_pagination_default from "./variants_pagination.js";
import variants_popover_default from "./variants_popover.js";
import variants_presence_default from "./variants_presence.js";
import variants_prose_default from "./variants_prose.js";
import variants_progress_circle_default from "./variants_progress_circle.js";
import variants_radio_default from "./variants_radio.js";
import variants_radio_group_default from "./variants_radio_group.js";
import variants_rich_text_editor_default from "./variants_rich_text_editor.js";
import variants_root_layout_default from "./variants_root_layout.js";
import variants_scroller_default from "./variants_scroller.js";
import variants_segmented_control_default from "./variants_segmented_control.js";
import variants_select_menu_default from "./variants_select_menu.js";
import variants_skeleton_default from "./variants_skeleton.js";
import variants_split_button_default from "./variants_split_button.js";
import variants_stack_default from "./variants_stack.js";
import variants_tab_group_default from "./variants_tab_group.js";
import variants_text_default from "./variants_text.js";
import variants_toast_default from "./variants_toast.js";
import variants_toggle_default from "./variants_toggle.js";
import variants_tooltip_default from "./variants_tooltip.js";
import variants_validation_messages_default from "./variants_validation_messages.js";
//#region src/variants/variants.js
function variants() {
	return {
		DtAvatar: variants_avatar_default,
		DtBadge: variants_badge_default,
		DtBanner: variants_banner_default,
		DtButton: variants_button_default,
		DtButtonGroup: variants_button_group_default,
		DtBox: variants_box_default,
		DtBreadcrumbs: variants_breadcrumbs_default,
		DtCard: variants_card_default,
		DtCheckbox: variants_checkbox_default,
		DtCheckboxGroup: variants_checkbox_group_default,
		DtChip: variants_chip_default,
		DtCollapsible: variants_collapsible_default,
		DtCombobox: variants_combobox_default,
		DtComboboxWithPopover: variants_combobox_with_popover_default,
		DtDatepicker: variants_datepicker_default,
		DtDescriptionList: variants_description_list_default,
		DtDropdown: variants_dropdown_default,
		DtEmoji: variants_emoji_default,
		DtEmojiPicker: variants_emoji_picker_default,
		DtEmojiTextWrapper: variants_emoji_text_wrapper_default,
		DtEmptyState: variants_empty_state_default,
		DtFilterPill: variants_filter_pill_default,
		DtHovercard: variants_hovercard_default,
		DtIcon: variants_icon_default,
		DtIllustration: variants_illustration_default,
		DtImageViewer: variants_image_viewer_default,
		DtInput: variants_input_default,
		DtInputGroup: variants_input_group_default,
		DtItemLayout: variants_item_layout_default,
		DtKeyboardShortcut: variants_keyboard_shortcut_default,
		DtLazyShow: variants_lazy_show_default,
		DtLink: variants_link_default,
		DtListItem: variants_list_item_default,
		DtListItemGroup: variants_list_item_group_default,
		DtLoader: variants_loader_default,
		DtModal: variants_modal_default,
		DtModeIsland: variants_mode_island_default,
		DtNotice: variants_notice_default,
		DtPagination: variants_pagination_default,
		DtPopover: variants_popover_default,
		DtPresence: variants_presence_default,
		DtProse: variants_prose_default,
		DtProgressCircle: variants_progress_circle_default,
		DtRadio: variants_radio_default,
		DtRadioGroup: variants_radio_group_default,
		DtRichTextEditor: variants_rich_text_editor_default,
		DtRootLayout: variants_root_layout_default,
		DtScroller: variants_scroller_default,
		DtSegmentedControl: variants_segmented_control_default,
		DtSelectMenu: variants_select_menu_default,
		DtSkeleton: variants_skeleton_default,
		DtSplitButton: variants_split_button_default,
		DtStack: variants_stack_default,
		DtTabGroup: variants_tab_group_default,
		DtText: variants_text_default,
		DtToast: variants_toast_default,
		DtToggle: variants_toggle_default,
		DtTooltip: variants_tooltip_default,
		DtValidationMessages: variants_validation_messages_default
	};
}
//#endregion
export { variants as default };

//# sourceMappingURL=variants.js.map